var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnergySaving = function SvgEnergySaving(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "energySaving_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#energySaving_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5c-.889 0-1.73-.146-2.52-.438a7.577 7.577 0 0 1-2.147-1.208l-1.062 1.063a.763.763 0 0 1-.583.24.838.838 0 0 1-.584-.261.811.811 0 0 1-.25-.594c0-.23.083-.427.25-.594l1.042-1.041a7.54 7.54 0 0 1-1.208-2.157A7.26 7.26 0 0 1 2.5 10c0-2.083.733-3.854 2.198-5.313C6.163 3.23 7.93 2.5 10 2.5h5.833c.459 0 .851.163 1.177.49.327.326.49.718.49 1.177V10c0 2.07-.73 3.837-2.188 5.302C13.854 16.767 12.084 17.5 10 17.5Zm-1.104-3.438 4.312-3.854a.397.397 0 0 0 .125-.448c-.055-.173-.18-.274-.375-.302l-3.375-.333 2.021-2.77a.3.3 0 0 0 .073-.22.407.407 0 0 0-.094-.218.33.33 0 0 0-.479 0L6.813 9.77a.397.397 0 0 0-.125.448c.055.173.18.274.375.302l3.375.333-2.042 2.771a.419.419 0 0 0-.063.219c0 .076.035.15.104.219.07.069.146.104.23.104.083 0 .16-.035.229-.104Z",
    fill: "#40424C"
  }))));
};
export default SvgEnergySaving;